import {
  CustomLabel,
  FlexContainer,
  InfoIcon,
  Input,
  SingleSelect,
  TextInputWithDropdown,
} from "@mindmemobile/mm-shared-global";
import React from "react";
import { DescriptionCell, LabelCell } from "../styles";
import { ItemIncreasePriceBy } from "../enums";
import styled from "styled-components";
type IncreasePriceIntervalSectionProps = {
  increasePriceInterval: string;
  increasePriceValue: string;
  increasePriceBy: keyof typeof ItemIncreasePriceBy;
  className?: string;
  onIncreasePriceIntervalChange: (value: string) => void;
  onIncreasePriceValueChange: (value: string, isBlur?: boolean) => void;
  onIncreasePriceByChange: (value: string) => void;
  getOptions: (fieldName: string) => any[];
  hasError: (fieldName: string) => boolean;
  showMerged?: boolean;
  disablePriceIntervalSelect?: boolean;
  errorMessage?: string;
};
const PriceIntervalWrapper = styled(FlexContainer)`
  .error-message {
    line-height: 16px;
  }
`;

export const PriceIntervalSection: React.FC<
  IncreasePriceIntervalSectionProps
> = ({
  increasePriceInterval,
  increasePriceValue,
  increasePriceBy,
  onIncreasePriceIntervalChange,
  onIncreasePriceValueChange,
  onIncreasePriceByChange,
  getOptions,
  hasError,
  className,
  showMerged = false,
  disablePriceIntervalSelect,
  errorMessage,
}) => {
  const increasePriceIntervalElement = (
    <SingleSelect
      selectedKey={increasePriceInterval}
      nameKeys={["label"]}
      valueKeys={["value"]}
      options={[getOptions("increasePriceInterval")]}
      onChange={(option) =>
        !disablePriceIntervalSelect &&
        onIncreasePriceIntervalChange(option.value)
      }
      hasError={hasError("increasePriceInterval")}
      className="dpdn-no-separator price-increase-interval"
      disabled={disablePriceIntervalSelect}
      errorMessage={errorMessage}
    />
  );

  const hasErrorInTextInputWithDropdown =
    hasError("increasePriceBy") ||
    hasError("increasePriceValue") ||
    hasError("increasePriceAmount") ||
    hasError("increasePricePercentage");
  return (
    <PriceIntervalWrapper className={`label-description-row ${className}`}>
      <LabelCell>
        <CustomLabel lineHeight="40px" fontSize="16px">
          Price Increase
        </CustomLabel>
        <InfoIcon />
      </LabelCell>
      <DescriptionCell>
        <FlexContainer spacing={15} fxWrap="nowrap">
          {increasePriceInterval === "None" ? (
            increasePriceIntervalElement
          ) : (
            <>
              {increasePriceIntervalElement}
              {!showMerged ? (
                <>
                  <div>
                    <FlexContainer spacing={15} className="dollar-usd-input">
                      <Input
                        value={increasePriceValue}
                        type="text"
                        error={
                          hasError("increasePriceValue") ||
                          hasError("increasePriceAmount") ||
                          hasError("increasePricePercentage")
                        }
                        className="styled-input number-selector"
                        onChange={(e, isBlur) =>
                          onIncreasePriceValueChange(e.target.value, isBlur)
                        }
                      />
                    </FlexContainer>
                  </div>
                  <SingleSelect
                    selectedKey={increasePriceBy}
                    nameKeys={["label"]}
                    valueKeys={["value"]}
                    options={[getOptions("increasePriceBy")]}
                    onChange={(option) => onIncreasePriceByChange(option.value)}
                    hasError={hasError("increasePriceBy")}
                    className="dpdn-no-separator price-increase-amount"
                  />
                </>
              ) : (
                <TextInputWithDropdown
                  textInputValue={
                    parseFloat(increasePriceValue) > 0 ? increasePriceValue : ""
                  }
                  dropdownValue={increasePriceBy}
                  error={hasErrorInTextInputWithDropdown}
                  dropdownOptions={[getOptions("increasePriceBy")]}
                  onTextChange={(value) => onIncreasePriceValueChange(value)}
                  onDropdownChange={(option) =>
                    onIncreasePriceByChange(option.value)
                  }
                  placeholderForTextInput={
                    increasePriceBy === "Percent" ? "0.00" : "0.00"
                  }
                  errorMessage={
                    hasErrorInTextInputWithDropdown ? errorMessage : ""
                  }
                  className={`${increasePriceBy === "Percent" ? "percent-left-input" : "dollar-input"} charcoal-label-input price-interval-input`}
                />
              )}
            </>
          )}
        </FlexContainer>
      </DescriptionCell>
    </PriceIntervalWrapper>
  );
};

export default PriceIntervalSection;
